import AreaInput from "../../../../../components/AreaInput";
import CurrencyInput from "../../../../../components/Currency";
import {
  FieldLabel,
  DESCRIPTION_INPUT_CLASS,
} from "../../../../../components/propertyDescription/descriptionUi";
import { Wrapper } from "./styles";

interface IProps {
  label: string;
  component: string;
  value: number;
  onChange: (value: number | string) => void;
}

function PropertyValue(props: IProps) {
  return (
    <Wrapper>
      <FieldLabel>{props.label}</FieldLabel>
      {props.component === "currency" ? (
        <CurrencyInput
          className={DESCRIPTION_INPUT_CLASS}
          value={props.value}
          onValueChange={props.onChange}
        />
      ) : (
        <AreaInput
          type="text"
          value={props.value}
          onChange={(e) => props.onChange(e.target.value)}
          className={DESCRIPTION_INPUT_CLASS}
        />
      )}
    </Wrapper>
  );
}

export default PropertyValue;
